var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#118f84;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.928,118.452L322.17,54.654h7.549c11.716,0,21.204-9.489,21.204-21.205V21.204 C350.923,9.496,341.435,0,329.719,0h-73.71h-73.727c-11.7,0-21.188,9.496-21.188,21.204V33.45c0,11.716,9.488,21.205,21.188,21.205 h7.566l-40.758,63.797c-16.588,25.957-25.404,56.121-25.404,86.926V441.88c0,38.722,31.398,70.12,70.137,70.12h124.373 c38.739,0,70.12-31.398,70.12-70.12V205.377C388.315,174.572,379.517,144.408,362.928,118.452z M348.054,441.88 c0,16.46-13.399,29.852-29.86,29.852H193.822c-16.461,0-29.86-13.392-29.86-29.852V218.36 c77.237-14.81,112.449,42.248,184.092,38.306V441.88z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.26f92cd621a989915f668779a54ee31e.svg";
export { ForwardRef as ReactComponent };